export default __webpack_public_path__ + "static/media/teamsnap_for_brands_logo_white.273df7ef.png";